import { Card, CardBody, CardFooter, CardTitle, Grid, GridItem, Title } from '@patternfly/react-core';
import * as React from 'react';
import { Link } from 'react-router-dom';
import EventInterface from '@app/Interface/EventInterface';
import ItemLoader from '../ItemLoader';
import EventHelper from '@app/Service/EventHelper';
import PageRouteInterface from '@app/Interface/PageRouteInterface';
import ErrorResponseInterface from '@app/Interface/ErrorResponseInterface';

interface UpcomingEventsProps {
    isLoading: boolean;
    events: EventInterface[] | ErrorResponseInterface;
    eventPageRoute: PageRouteInterface;
}


const UpcomingEvents: React.FC<UpcomingEventsProps> = ({ isLoading, events, eventPageRoute }) => {

    let eventsToView: EventInterface[] = [];

    if (Array.isArray(events)) {
        eventsToView = events;
    }

    if (isLoading) {
        return <ItemLoader />;
    }

    return (

        <div>
            <Title headingLevel={'h2'} className="pf-u-mb-md">Upcoming Events</Title>
            {eventsToView.length === 0 &&
                <p><em>No upcoming events to display</em></p>
            }

            {eventsToView.map((event, index) =>
                <Card key={event.id} id={`upcoming-event-card-${index + 1}`} isFlat isCompact>
                    <Grid>
                        <GridItem span={3} style={{ borderRight: "1px solid var(--pf-global--BorderColor--100)" }}>
                            <CardBody style={{ textAlign: "center" }}>
                                {EventHelper.getDashboardEventDateMarkup(event)}
                            </CardBody>
                        </GridItem>
                        <GridItem span={9}>
                            <CardTitle>{event.title}</CardTitle>
                            {event.eventLocation &&
                                <CardBody>
                                    {event.eventLocation}
                                </CardBody>
                            }
                            <CardFooter>
                                <Link to={{ pathname: eventPageRoute.path, search: `?event=${event.slug}`, state: { pageId: eventPageRoute.id } }}>
                                    More details
                                </Link>
                            </CardFooter>
                        </GridItem>
                    </Grid>
                </Card>
            )}

            <div style={{ textAlign: "right" }}>
                <Link to={eventPageRoute.path}>All events &gt;</Link>
            </div>
        </div>

    );

}

export default UpcomingEvents;